import { useMemo } from 'react';
export const useServiceUrlsProvider = ({
  serviceUrls
}) => useMemo(() => serviceUrls,
// eslint-disable-next-line react-hooks/exhaustive-deps -- Service Urls are not refetched and changed on the client side
[]);
//# sourceMappingURL=useServiceUrlsProvider.js.map